<template>
  <div class="grid__view">
    <h4 class="subtitle-2 text-uppercase mb-3">Full Grid Layout</h4>
    <div class="grid__wrap blue-grey lighten-5 mb-3">
      <g-container>
        <g-row>
          <g-column v-for="grid in grids"
            :key="grid"
          >
           {{ grid + 1}}
          </g-column>
        </g-row>
      </g-container>
    </div>
    <v-divider class="mt-4 mb-5"></v-divider>
    <h4 class="subtitle-2 text-uppercase mb-3">Customize Grid Layout</h4>
    <div class="caption blue-grey--text lighten-3 mb-5">
      <span>Note:</span>
      <ol>
        <li>Click on any column to update grid structure</li>
        <li>Hover to view more info</li>
      </ol>
    </div>
    <div class="grid__wrap blue-grey lighten-5 mb-3">
      <g-container>
        <g-rows v-for="(row, index) in rows"
          :key="index" :row="row">
        </g-rows>
      </g-container>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex';

export default {
  name: 'grid-view',
  components: {},
  computed: {
    ...mapState(['rows']),
    ...mapGetters([
      'details',
      'cw',
      'gutterSpace',
      'totalGrids',
      'gridSize',
      'grids',
      'totalGutterSpace',
      'totalGridSpace',
      'gutterUnitSpace',
    ]),
  },
};
</script>
